import { SET_FILTER } from "../types";

const FiltersReducer = (state, { type, payload }) => {
  switch (type) {
    case SET_FILTER:
      const { key, value } = payload;
      return { ...state, [key]: value };
    default:
      return { ...state };
  }
};
export default FiltersReducer;
